// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__dx5TJ > div {
  width: 90%; }

.styles_card__XwVjT {
  border: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/BoothPastCyclesTab/styles.module.scss"],"names":[],"mappings":"AACA;EAEQ,UAAU,EAAA;;AAIlB;EACI,YAAY,EAAA","sourcesContent":["\n.container { \n    & > div {\n        width: 90%;\n    }\n}\n\n.card {\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__dx5TJ`,
	"card": `styles_card__XwVjT`
};
export default ___CSS_LOADER_EXPORT___;
